import { List as AntdList } from "antd"
import ComponentState from "../component-state/component-state"

const List = ({ dataSource, renderItem=()=>{}, key, listItemStyle, listItemClassName, children, error, loading, onErrorRetry, ...rest }) => {
  return !!error ? (
    <ComponentState onClick={onErrorRetry} btnLoading={loading} description={error?.message} status={error.status} />
  ) : (
    <AntdList
      loading={loading}
      dataSource={dataSource}
      renderItem={item => (
        <AntdList.Item key={key} style={listItemStyle} className={listItemClassName}>
          {renderItem(item)}
        </AntdList.Item>
      )}
      {...rest}
    >
      {children}
    </AntdList>
  )
}
export default List
